import {
    LANE_DETAILS_REQUEST,
    LANE_DETAILS_SUCCESS,
    LANE_DETAILS_FAILURE,
    SAVED_LANES_REQUEST,
    SAVED_LANES_SUCCESS,
    SAVED_LANES_FAILURE,
    ADD_SAVED_LANE_REQUEST,
    ADD_SAVED_LANE_SUCCESS,
    ADD_SAVED_LANE_FAILURE,
    DELETE_SAVED_LANE_REQUEST,
    DELETE_SAVED_LANE_SUCCESS,
    DELETE_SAVED_LANE_FAILURE
} from '../../actions/marketInsights/laneDetailsActions';

interface LaneDetails {
    currentLane: any;
    isFetching: boolean;
    savedLanes: any[];
    isFetchingSavedLanes: boolean;
    isUpdatingSavedLanes: boolean;
}

const fetchLanesReducer = (laneDetails: LaneDetails = {
    isFetching: false,
    currentLane: {},
    isFetchingSavedLanes: false,
    savedLanes: [],
    isUpdatingSavedLanes: false
}, action: any): LaneDetails => {
    switch (action.type) {
        case LANE_DETAILS_REQUEST: {
            return {
                ...laneDetails,
                isFetching: true
            };
        }
        case LANE_DETAILS_SUCCESS: {
            return {
                ...laneDetails,
                isFetching: false,
                currentLane: action.payload
            };
        }
        case LANE_DETAILS_FAILURE: {
            return {
                ...laneDetails,
                isFetching: false,
                currentLane: {}
            };
        }
        case SAVED_LANES_REQUEST: {
            return {
                ...laneDetails,
                isFetchingSavedLanes: true
            };
        }
        case SAVED_LANES_SUCCESS: {
            return {
                ...laneDetails,
                isFetchingSavedLanes: false,
                savedLanes: action.payload
            };
        }
        case SAVED_LANES_FAILURE: {
            return {
                ...laneDetails,
                isFetchingSavedLanes: false,
                savedLanes: []
            };
        }
        case ADD_SAVED_LANE_REQUEST: {
            return {
                ...laneDetails,
                isUpdatingSavedLanes: true
            };
        }
        case ADD_SAVED_LANE_SUCCESS: {
            return {
                ...laneDetails,
                isUpdatingSavedLanes: false
            };
        }
        case ADD_SAVED_LANE_FAILURE: {
            return {
                ...laneDetails,
                isUpdatingSavedLanes: false
            };
        }
        case DELETE_SAVED_LANE_REQUEST: {
            return {
                ...laneDetails,
                isUpdatingSavedLanes: true
            };
        }
        case DELETE_SAVED_LANE_SUCCESS: {
            const updateSavedLanes = laneDetails.savedLanes.filter((lane: any) => {
                return lane.lane_name !== action.payload;
            });

            return {
                ...laneDetails,
                isUpdatingSavedLanes: false,
                savedLanes: updateSavedLanes
            };
        }
        case DELETE_SAVED_LANE_FAILURE: {
            return {
                ...laneDetails,
                isUpdatingSavedLanes: false
            };
        }
        default:
            return laneDetails;
    }
};

export default fetchLanesReducer;
